import React, {
  CSSProperties,
  forwardRef,
  ReactNode,
  RefObject,
  TextareaHTMLAttributes,
} from 'react';

import { useRows } from '~/components/chat';

import styles from './ChatDocumentContextInput.module.scss';

export interface ChatInputFieldProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  children?: ReactNode;
  inputRef?: RefObject<HTMLTextAreaElement>;
  maxRows?: number;
  style?: CSSProperties & { [key: `--${string}`]: string | number };
}

export const ChatInputField = forwardRef<HTMLDivElement, ChatInputFieldProps>(
  ({ children, onChange, inputRef, value, maxRows, ...rest }, ref) => {
    const { rows, updateRows } = useRows({
      value,
      maxRows,
      textAreaRef: inputRef,
    });

    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      updateRows(event);
      onChange?.(event);
    };

    return (
      <div className={styles.chatInputFieldWrapper} ref={ref}>
        <div className={styles.chatInputFieldContainer}>
          <div className={styles.textAreaWrapper} data-chat-textarea-wrapper>
            <textarea
              id="dropdown-trigger"
              className={styles.textareaElement}
              ref={inputRef}
              rows={rows}
              value={value}
              onChange={handleChange}
              {...rest}
              data-testid="chat-input"
              data-chat-textarea-element
            />
            {children}
          </div>
        </div>
      </div>
    );
  }
);
